import useSWR from 'swr'
import { getApiVersion, http } from '../utils/domain'
// import { stringifyQuery } from '../utils/query'

const prefix = (appId) => {
  return `${getApiVersion()}/apps/${appId}/users`
}

export const fetchUsers = (appId) => {
  return http().get(prefix(appId)).json()
}

// 根据id获取用户信息
export const fetchUsersByIds = (appId, ids) => {
  return http()
    .post(`${prefix(appId)}/ids`, ids)
    .json()
}

// 获取用户信息
export const fetchUserInfo = () => {
  return http().get(`${getApiVersion()}/users/my`).json()
}

// 用戶退出登录
export const userLogout = () => {
  return http().get(`${getApiVersion()}/personnelManagement/logoutByToken`)
}

// 新增的【人员管理】获取基础用户信息接口
export const fetchUserInfoNormal = () => {
  return http().get(`${getApiVersion()}/personnelManagement/baseUser`).json()
  // .catch((err) => {
  //   console.log(err, '这里')
  //   return {}
  // })
}

// 【人员管理】获取组织用户详情
export const fetchOrgUser = (appId) => {
  return http()
    .get(`${getApiVersion()}/personnelManagement/orgUser?appId=${appId}`)
    .json()
}

// 根据id获取用户信息
export const usersInfoByUserIds = (appId, ids) => {
  return http()
    .get(`${prefix(appId)}/getByUserIds?ids=${ids}`)
    .json()
}

export const getUsers = (appId, orgId) => {
  return http()
    .get(`${prefix(appId)}${orgId ? `?orgId=${orgId}` : ''}`)
    .json()
}
// 获取组织下的用户（orgId不传则为全部用户
export const usersByOrg = (appId, orgId) => {
  const { data, error, mutate } = useSWR('users', () => getUsers(appId, orgId))

  return {
    orgUsers: data,
    isLoading: !error && !data,
    isError: error,
    orgUsersMutate: mutate,
  }
}
// 获取组织下的用户 (自动监听orgId变化)
export const useUserList = (appId, orgId) => {
  const { data, error } = useSWR(['users', orgId], (_, _orgId) =>
    getUsers(appId, _orgId)
  )

  return {
    orgUsers: data,
    isLoading: !error && !data,
    isError: error,
  }
}

export const allUsers = (appId) => {
  return http()
    .get(`${prefix(appId)}`)
    .json()
}

// 待审批员工swr
export const usersPendingApprovalBySwr = (appId) => {
  const { data, mutate } = useSWR(`${prefix(appId)}/approve/list`)
  return {
    users: data && data.data ? data.data : [],
    usersMutate: mutate,
  }
}

// 待审批员工
export const usersPendingApproval = (appId) => {
  return http()
    .get(`${prefix(appId)}/approve/list`)
    .json()
}

// 离职员工列表swr
export const usersQuitBySwr = (appId) => {
  const { data, mutate } = useSWR(`${prefix(appId)}/quit/list`)
  return {
    resignedUsers: data,
    resignedUsersMutate: mutate,
  }
}

// 离职员工列表
export const usersQuit = (appId) => {
  return http()
    .get(`${prefix(appId)}/quit/list`)
    .json()
}

// 未分组员工列表swr
export const usersUngroupedBySwr = (appId) => {
  const { data, mutate } = useSWR(`${prefix(appId)}/none_grouped`)
  return {
    users: data && data.data ? data.data : [],
    usersMutate: mutate,
  }
}

// 未分组员工列表
export const usersUngrouped = (appId) => {
  return http()
    .get(`${prefix(appId)}/none_grouped`)
    .json()
}

// 未激活员工列表swr
export const usersUnActivateBySwr = (appId) => {
  const { data, mutate } = useSWR(`${prefix(appId)}/not_activate`)
  return {
    users: data && data.data ? data.data : [],
    usersMutate: mutate,
  }
}

// 未激活员工列表
export const usersUnActivate = (appId) => {
  return http()
    .get(`${prefix(appId)}/not_activate`)
    .json()
}

// 编辑用户
export const editUser = (appId, formData) => {
  return http()
    .put(`${prefix(appId)}`, formData)
    .json()
}

// 删除用户
export const deleteUsers = (appId, ids) => {
  return http()
    .delete(`${prefix(appId)}?ids=${ids}`)
    .json()
}

// 重置密码
export const resetUserPwd = (appId, userId, password) => {
  return http()
    .put(`${prefix(appId)}/${userId}/password?password=${password}`)
    .json()
}

// 用户审批通过
export const approvedUser = (appId, userIds) => {
  return http()
    .post(`${prefix(appId)}/approve?ids=${userIds}`)
    .json()
}

// 用户审批不通过
export const rejectUser = (appId, userIds) => {
  return http()
    .post(`${prefix(appId)}/reject?ids=${userIds}`)
    .json()
}

// 用户启用
export const activeUser = (appId, userIds) => {
  return http()
    .post(`${prefix(appId)}/active?ids=${userIds}`)
    .json()
}

// 用户禁用
export const inactiveUser = (appId, userIds) => {
  return http()
    .post(`${prefix(appId)}/inactive?ids=${userIds}`)
    .json()
}

// 用户批量转移部门
export const changeOrgBatch = (appId, ids, orgId) => {
  return http()
    .post(`${prefix(appId)}/change_org_batch?ids=${ids}&orgId=${orgId}`)
    .json()
}

// 用户批量配置角色
export const changeRoleBatch = (appId, ids, roleId) => {
  return http()
    .post(`${prefix(appId)}/change_role_batch?ids=${ids}&roleId=${roleId}`)
    .json()
}

// 用户离职
export const userQuit = (appId, userId, toUserId) => {
  return http()
    .post(
      `${prefix(appId)}/quit?userId=${userId}${
        toUserId ? `&toUserId=${toUserId}` : ''
      }`
    )
    .json()
}

// 检查用户名是否存在
export const checkUserNames = (appId, formData) => {
  return http()
    .post(`${prefix(appId)}/checkUserNames`, formData)
    .json()
}

// 检查手机号是否存在
export const checkUserMobiles = (appId, formData, orgId) => {
  return http()
    .post(
      `${prefix(appId)}/check_mobile${orgId ? `?orgId=${orgId}` : ''}`,
      formData
    )
    .json()
}

// 新增的【人员管理】批量添加子账户
export const addSubUsersBatchNormal = (appId, formData) => {
  return http()
    .post(`${getApiVersion()}/personnelManagement/orgBatch`, formData)
    .json()
}

// 之前的批量添加子账户
export const addSubUsersBatch = (appId, formData) => {
  return http()
    .post(`${prefix(appId)}/addBatch`, formData)
    .json()
}

// 手机号批量邀请
export const addInviteUsersBatch = (appId, formData) => {
  return http()
    .post(`${prefix(appId)}/mobile_invite`, formData)
    .json()
}

// 判断用户是否有案件
export const checkIsUsersHasCase = (appId, ids) => {
  return http()
    .get(`${prefix(appId)}/hasCase?ids=${ids}`)
    .json()
}

// 获取用户模板接口
export const getUserTemplate = (appId, params) => {
  return http()
    .get(`${prefix(appId)}/excelImport`, {
      searchParams: params,
      throwHttpErrors: false,
      parseJson: (res) => {
        return res
      },
    })
    .json()
}

// 上传用户 excel 接口
export const uploadUserExcel = (appId, formData) => {
  return http()
    .post(`${prefix(appId)}/excelImport`, null, {
      throwHttpErrors: false,
      // headers: makeHeaders(),
      body: formData,
    })
    .json()
}

// 用户加入项目
export const joinApp = (appId, formData) => {
  return http()
    .post(`${prefix(appId)}/invite`, formData)
    .json()
}

// 获取用户信息+表单权限
export const fetchUserPower = (appId, tpl) => {
  if (tpl) {
    return http()
      .get(
        `${getApiVersion()}/apps/${appId}/informationStorage/my?purpose=app_data_drop_select&tpl=${tpl}`
      )
      .json()
  }
  return http()
    .get(
      `${getApiVersion()}/apps/${appId}/informationStorage/my?purpose=app_data_drop_select`
    )
    .json()
}

// 扫描二维码
export const scanQrCode = (appId, formData) => {
  return http()
    .post(
      `${getApiVersion()}/apps/${appId}/daDongRefuseClassification/appLogin?scanResult=${
        formData.scanResult
      }`,
      {
        body: null,
      }
    )
    .json()
}

export const getUsersAll = (appId, orgId) => {
  return http()
    .get(`${prefix(appId)}${orgId ? `&orgId=${orgId}` : ''}`)
    .json()
}

export const usersByOrgAll = (appId, orgId) => {
  const { data, error, mutate } = useSWR('users', () =>
    getUsersAll(appId, orgId)
  )
  return {
    orgUsers: data,
    isLoading: !error && !data,
    isError: error,
    orgUsersMutate: mutate,
  }
}
